import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../CustomButton/CustomButton";
import { getHomepageAction } from "../../reduxThings/slices/DigipankSlices";
import {
  uploadHomepageData,
  validateHomepageJson,
} from "../../services/homepageApi";
import { getAccessToken } from "../../util/auth";
import { useAuth } from "../../hooks/useAuth";
import "./HomepageJsonUpload.scss";

const HomepageJsonUpload = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  if (!isAdmin) {
    return null;
  }

  const handleButtonClick = () => {
    const token = getAccessToken();
    if (!token) {
      setMessage("Please login as admin before uploading.");
      navigate("/login");
      return;
    }
    setMessage("");
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";

    if (!file) {
      return;
    }

    const token = getAccessToken();
    if (!token) {
      setMessage("Please login as admin before uploading.");
      navigate("/login");
      return;
    }

    setUploading(true);
    setMessage("");

    try {
      const fileText = await file.text();
      const homepageJson = JSON.parse(fileText);
      const validationError = validateHomepageJson(homepageJson);

      if (validationError) {
        throw new Error(validationError);
      }

      await uploadHomepageData(homepageJson, token);
      dispatch(getHomepageAction());
      setMessage("Homepage JSON uploaded successfully.");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to upload homepage JSON.";
      setMessage(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="homepage-json-upload">
      <input
        ref={fileInputRef}
        type="file"
        accept=".json,application/json"
        className="homepage-json-upload__input"
        onChange={handleFileChange}
      />
      <CustomButton
        title={uploading ? "Uploading..." : "homepage JSON Upload"}
        className="homepage-json-upload__btn"
        onClick={handleButtonClick}
      />
      {message && <p className="homepage-json-upload__message">{message}</p>}
    </div>
  );
};

export default HomepageJsonUpload;
